/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import ICONS from "../../../../assets/Icons";
import {
  disableSwitcher,
  enableSwitcher,
} from "../../../../redux/features/multiEntitySwitcher/multiEntitySwitcher";
import LargePopupRedirect from "../../../_utils/CommonPopups/CommonLargePopupRedirect";
import ScheduleInternalTransactionViewSchedules from "../../../../containers/Transactions/ScheduleInternalTransactions/ScheduleInternalTransactionViewSchedules";

const ScheduleInternalTransactionViewAllPopup = ({
  isOpen = true,
  onClose,
  headerTitle = "",
  headerSubtitle = "",
  headerIcon,
  showHeaderIcon,
  showFullViewButton = false,
  onFullView,
  fullViewDisabled = false,
  fullViewDisabledBackgroundColor = "var(--text-disabled)",
  fullViewBackgroundColor = "var(--primary-nav)",
  fullViewTextColor = "var(--text-primary)",
  fullViewHoverOption = "white",
  fullViewIcon = ICONS?.REDIRECT,
  fullViewTitle = "",
  closeButtonIcon = ICONS?.CLOSE,
  closeButtonDisabled = false,
  closeButtonLoading = false,
  closeButtonBackgroundColor = "var(--primary-nav)",
  closeButtonDisabledBackgroundColor = "var(--text-disabled)",
  closeButtonHoverOption = "white",
  closeButtonType = "button",
  closeButtonRef = null,
  closeButtonTitle = "Close",
  showFooter = false,
  footerTitle = "",
  showFooterButton = false,
  footerButtonText = "Proceed",
  onFooterButtonClick,
  footerButtonBackgroundColor,
  footerButtonTextColor = "var(--text-primary)",
  footerButtonHoverOption = "dark",
  footerButtonOutlineColor = "",
  footerButtonDisabled = false,
  footerButtonType = "button",
  showBackdrop = false,
  className = "",
  stopClickPropagation = false,
  ContentComponent = ScheduleInternalTransactionViewSchedules,
  contentProps = {},
  children,
  popupProps = {},
  disableEntitySwitcher = false,
  onUnmount,
  inActiveVariantNeeded
}) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (!isOpen || !disableEntitySwitcher) return;

    dispatch(disableSwitcher());

    return () => {
      dispatch(enableSwitcher());
      onUnmount?.();
    };
  }, [isOpen, disableEntitySwitcher, dispatch, onUnmount]);

  if (!isOpen) return null;



  const popup = (
    <LargePopupRedirect
      headerTitle={headerTitle}
      headersubtext={headerSubtitle}
      isHeaderImgNeed={showHeaderIcon ?? !!headerIcon}
      ShowIcon={headerIcon}
      isfullViewrequired={showFullViewButton}
      fullviewIsDisabled={fullViewDisabled}
      fullviewdisabledBgColor={fullViewDisabledBackgroundColor}
      fullviewenabledBgColor={fullViewBackgroundColor}
      fullviewenabledTextColor={fullViewTextColor}
      fullviewhoverOption={fullViewHoverOption}
      fullviewicon={fullViewIcon}
      fullviewhandleFunction={onFullView}
      fullviewtitle={fullViewTitle}
      closeiconhandleFunction={onClose}
      closeiconisLoading={closeButtonLoading}
      closeiconisDisabled={closeButtonDisabled}
      closeiconenabledBgColor={closeButtonBackgroundColor}
      closeicondisabledBgColor={closeButtonDisabledBackgroundColor}
      closeiconhoverOption={closeButtonHoverOption}
      closeiconbtnType={closeButtonType}
      closeiconbuttonRef={closeButtonRef}
      closeicontitle={closeButtonTitle}
      closeicon={closeButtonIcon}
      isbottomSectionneed={showFooter}
      bottomHeaderTextNeed={showFooter && !!footerTitle}
      bottomHeaderText={footerTitle}
      confirmbtnrequired={showFooterButton}
      btnType={footerButtonType}
      btnText={footerButtonText}
      handleFunction={onFooterButtonClick}
      enabledBgColor={footerButtonBackgroundColor || "var(--negative-act)"}
      enabledTextColor={footerButtonTextColor}
      hoverOption={footerButtonHoverOption}
      outLineColor={footerButtonOutlineColor}
      fullWidthRequired={false}
      isDisabled={footerButtonDisabled}
    inActiveVariantNeeded={inActiveVariantNeeded || false}
      {...popupProps}
    >
      {children ?? (
        <ContentComponent
          onClose={onClose}
          {...contentProps}
        />
      )}
    </LargePopupRedirect>
  );

  let wrappedPopup = popup;

  if (stopClickPropagation || className) {
    wrappedPopup = (
      <div
        onClick={
          stopClickPropagation ? (event) => event.stopPropagation() : undefined
        }
        className={`w-width-full h-height-full ${className}`}
      >
        {popup}
      </div>
    );
  }

  if (!showBackdrop) {
    return wrappedPopup;
  }

  return <>{wrappedPopup}</>;
};

export default ScheduleInternalTransactionViewAllPopup;
